// extracted by mini-css-extract-plugin
export var planCard = "_vb-0";
export var planList = "_vb-1";